import SettingsTextField from "./fields/SettingsTextField";
import SettingsToggleField from "./fields/SettingsToggleField";
import SettingsDropdownField from "./fields/SettingsDropdownField";

function SettingsFieldRenderer({
  id,
  fieldKey,
  field,
  disabled = false,
  onChange,
}) {
  const fieldType = String(field?.type || "").toUpperCase();

  switch (fieldType) {
    case "TEXT":
      return (
        <SettingsTextField
          id={id}
          value={field?.value ?? ""}
          disabled={disabled}
          multiline={Boolean(field?.multiline)}
          onChange={(nextValue) => onChange(fieldKey, nextValue)}
        />
      );

    case "TOGGLE":
      return (
        <SettingsToggleField
          id={id}
          value={Boolean(field?.value)}
          disabled={disabled}
          onChange={(nextValue) => onChange(fieldKey, nextValue)}
        />
      );

    case "DROPDOWN":
      return (
        <SettingsDropdownField
          id={id}
          value={field?.value ?? ""}
          options={Array.isArray(field?.options) ? field.options : []}
          disabled={disabled}
          onChange={(nextValue) => onChange(fieldKey, nextValue)}
        />
      );

    default:
      return (
        <div className="settings-unsupported-field">
          Unsupported field type: {field?.type || "UNKNOWN"}
        </div>
      );
  }
}

export default SettingsFieldRenderer;